import { PRIVATE_BUSINESS_NAME_LABEL } from '../constants'
import { buildBusinessListItem } from './build-business-items'

export function setListOfNewZealandBusinessItems(businesses) {
  let businessDetails = ``
  businesses.forEach(value => {
    const { entityName, nzbn: nzbnNumber } = value

    if (entityName) {
      businessDetails += buildBusinessListItem(entityName, nzbnNumber)
    } else {
      businessDetails += buildBusinessListItem(
        PRIVATE_BUSINESS_NAME_LABEL,
        nzbnNumber
      )
    }
  })
  return businessDetails
}

export function setListOfAustralianBusinessItems(businesses) {
  let businessDetails = ``
  let nameOfBusiness = ``
  businesses &&
    businesses.forEach(value => {
      const {
        mainName,
        mainTradingName,
        legalName,
        businessName,
        otherTradingName,
        ABN: { identifierValue: abnNumber },
      } = value

      let isLegalName = true

      if (mainName || mainTradingName || legalName || businessName || otherTradingName) {
        if (mainName) {
          nameOfBusiness = mainName.organisationName
        } else if (mainTradingName) {
          isLegalName = false
          nameOfBusiness = mainTradingName.organisationName
        } else if (otherTradingName) {
          isLegalName = false
          nameOfBusiness = otherTradingName.organisationName
        } else if (businessName) {
          isLegalName = false
          nameOfBusiness = businessName.organisationName
        } else if (legalName) {
          let businessLegalName = ``
          if (legalName.fullName) {
            businessLegalName = legalName.fullName
          } else {
            businessLegalName += legalName.givenName
              ? `${legalName.givenName}`
              : ``
            businessLegalName += legalName.familyName
              ? ` ${legalName.familyName}`
              : ``
          }
          nameOfBusiness = businessLegalName
        } else {
          nameOfBusiness = `Business Name Unknown`
        }

        businessDetails += buildBusinessListItem(nameOfBusiness, abnNumber, isLegalName)
      }
    })
  return businessDetails
}
